"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _buttonview = _interopRequireDefault(require("@ckeditor/ckeditor5-ui/src/button/buttonview"));
var _plugin = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/plugin"));
var _clickobserver = _interopRequireDefault(require("@ckeditor/ckeditor5-engine/src/view/observer/clickobserver"));
// 这个模块是用来监听 click的

// 按钮的图标 SVG

var pdfIcon = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg t=\"1639729262140\" class=\"icon\" viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" p-id=\"893\" width=\"200\" height=\"200\"><path d=\"M853.333333 955.733333H170.666667V68.266667h409.6v68.266666H238.933333v750.933334h546.133334V341.333333h68.266666M307.2 648.533333h409.6v68.266667H307.2v-68.266667z m0-136.533333h409.6v68.266667H307.2v-68.266667z m0-136.533333h409.6v68.266666H307.2v-68.266666z m0-136.533334h273.066667v68.266667H307.2V238.933333z m341.333333-170.666666l204.8 204.8h-204.8V68.266667z\" p-id=\"894\"></path></svg>\n";
var BoxUI = exports.default = /*#__PURE__*/function (_Plugin) {
  function BoxUI() {
    (0, _classCallCheck2.default)(this, BoxUI);
    return (0, _callSuper2.default)(this, BoxUI, arguments);
  }
  (0, _inherits2.default)(BoxUI, _Plugin);
  return (0, _createClass2.default)(BoxUI, [{
    key: "init",
    value: function init() {
      this._defineBtnView();
    }

    // toolbar btn
  }, {
    key: "_defineBtnView",
    value: function _defineBtnView() {
      var _this = this;
      // 获取当前编辑器
      var editor = this.editor;
      // 从当前编辑器的配置中获取传入的自定义配置名称
      var pdf = this.editor.config.get('pdf');

      // 将自定义按钮添加到当前编辑器的组件工厂
      editor.ui.componentFactory.add('pdf', function (locale) {
        var view = editor.editing.view;
        var command = editor.commands.get('pdf');

        // 使用模块
        view.addObserver(_clickobserver.default);

        // 获取当前编辑器的按钮视图
        var buttonView = new _buttonview.default(locale);

        // 在按钮视图中注入自定义按钮的名称、图标
        buttonView.set({
          label: 'PDF',
          icon: pdfIcon,
          // 开启提示，当鼠标悬浮到按钮上，会显示 label 指定的 pdf 字样
          tooltip: true
        });

        // 将按钮的状态绑定到命令。
        buttonView.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled');
        // 单击(执行)按钮时执行命令。
        _this.listenTo(buttonView, 'execute', function () {
          editor.execute('pdf');
          // 执行自定义配置中指定的回调函数
          pdf.handler.call();
        });

        // 返回修改后的视图内容
        // return view
        return buttonView;
      });
    }
  }]);
}(_plugin.default);